import QRCode from 'qrcode';
import { mergeDictionariesReducer } from '../utils';

export const getQrCodesForIdsWithUrl = async (ids, urlTemplateFunction, errorHandler) => {
  const idQrPromiseDicts = await Promise.all(
    ids.map(id => generateQR(id, urlTemplateFunction(id), errorHandler))
  );
  return idQrPromiseDicts.reduce(mergeDictionariesReducer, {});
};

const generateQR = async (id, content, errorHandler) => {
  try {
    return { [id]: await QRCode.toDataURL(content, { errorCorrectionLevel: 'L', margin: 0 }) };
  } catch (err) {
    return errorHandler(err);
  }
};
